import React from "react";

const DownloadDemo = () => {
	const downloadFromS3 = async (fileUrl, fileName) => {
		try {
			// Fazendo a requisição para buscar o arquivo
			const response = await fetch(fileUrl);

			if (!response.ok) {
				throw new Error("Erro ao baixar o arquivo.");
			}

			// Convertendo a resposta para um blob
			const blob = await response.blob();

			// Criando um link para o arquivo
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = fileName; // Nome do arquivo a ser salvo
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(url); // Limpando URL do objeto
		} catch (error) {
			console.error("Erro ao baixar o arquivo:", error);
			alert("Não foi possível baixar o arquivo.");
		}
	};

	return (
		<div className="flex flex-col items-center min-h-screen bg-gray-100 p-4">
			<h1 className="text-2xl font-bold text-gray-800">Download de Arquivo</h1>
			<p className="mt-4 text-gray-600">Clique abaixo para baixar o arquivo.</p>
			<button
				onClick={() => {
					const link = document.createElement("a");
					link.href = "https://drive.google.com/file/d/1_Y3apc1krNE-RJUwKLfTjOGNYCl2qaE3/view?usp=sharing"; // URL do arquivo
					link.download = "SZPDV.exe"; // Nome do arquivo (opcional)
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}}
				className="mt-6 px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
			>
				Baixar Arquivo
			</button>
		</div>
	);
};

export default DownloadDemo;
// downloadFromS3(
// 	"https://seu-bucket-s3.amazonaws.com/seu-arquivo.txt", // URL do arquivo
// 	"meu-arquivo.txt" // Nome do arquivo salvo
// )
